import React from 'react';
import wedMeGoodLogo from '../assets/wed-me-good.png';
import weddingWireLogo from '../assets/weddingwire.svg';
import hindustanTimesLogo from '../assets/hindustan-times.png';
import indianChronicleLogo from '../assets/indian-chronicle-today.png';
import dailyHuntLogo from '../assets/daily-hunt.png';
import theHinduLogo from '../assets/the-hindu.png';

const FeaturedMediaSection = () => {
  const mediaOutlets = [
    { id: 1, name: 'WedMeGood', logo: wedMeGoodLogo },
    { id: 2, name: 'WeddingWire', logo: weddingWireLogo },
    { id: 3, name: 'Hindustan Times', logo: hindustanTimesLogo },
    { id: 4, name: 'Indian Chronicle Today', logo: indianChronicleLogo },
    { id: 5, name: 'Daily Hunt', logo: dailyHuntLogo },
    { id: 6, name: 'The Hindu', logo: theHinduLogo }
  ];

  return (
    <div className="w-full bg-beige py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-hero font-medium text-[#622935] mb-6 font-display">
            As Seen On
          </h2>
          <p className="text-lg md:text-xl text-black font-body">
            Featured in leading publications and media outlets
          </p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 items-center justify-items-center">
          {mediaOutlets.map((outlet) => (
            <div
              key={outlet.id}
              className="w-full max-w-[160px] h-16 sm:h-20 flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300 cursor-pointer group border border-gray-300"
            >
              {outlet.logo ? (
                <img
                  src={outlet.logo}
                  alt={`${outlet.name} logo`}
                  className={`max-h-10 sm:max-h-32 w-auto object-contain transition-transform duration-300 ease-out group-hover:scale-25`}
                  loading="lazy"
                />
              ) : (
                <span className="text-black font-medium text-sm sm:text-base text-center group-hover:text-[#622935] transition-colors duration-300 font-body">
                  {outlet.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedMediaSection;